import React, { useEffect, useState } from "react";
import { UserRound, ShieldCheck } from "lucide-react";
import "./ProfileFormAdmin.css";
import formatPhone from "../../../utils/formatPhone";
import MfaToggle from "../../../components/MfaToggle";

interface ProfileFormProps {
  profile: {
    fullName: string;
    phone: string;
    whatsapp: string;
    email: string;
  };
  onSave: (data: any) => void;
  onCancel: () => void;
  saving?: boolean;
  profileType?: string;
}

const ProfileFormAdmin: React.FC<ProfileFormProps> = ({
  profile,
  onSave,
  onCancel,
  saving = false,
  profileType = "Administrador",
}) => {
  const [formData, setFormData] = useState(profile);
  useEffect(() => { setFormData(profile); }, [profile]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "phone" || name === "whatsapp") {
      setFormData({ ...formData, [name]: formatPhone(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!saving) onSave(formData);
  };

  return (
    <div className="account-profile-sections">
      <form onSubmit={handleSubmit} className="account-panel" aria-label="Dados pessoais">
        <div className="account-panel-heading">
          <span className="account-section-icon"><UserRound size={20} /></span>
          <div><h2>Dados pessoais</h2></div>
        </div>
        <fieldset disabled={saving} className="account-fields">
        <div className="account-field account-field-wide">
          <label htmlFor="admin-profile-type" className="form-label">Tipo de perfil</label>
          <input
            id="admin-profile-type"
            type="text"
            className="form-control"
            value={profileType}
            readOnly
          />
        </div>

        <div className="account-field">
          <label htmlFor="admin-full-name" className="form-label">Nome completo</label>
          <input
            id="admin-full-name"
            autoComplete="name"
            placeholder="Seu nome completo"
            required
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="account-field">
          <label htmlFor="admin-phone" className="form-label">Telefone</label>
          <input
            id="admin-phone"
            type="tel"
            autoComplete="tel"
            placeholder="(00) 00000-0000"
            required
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="account-field">
          <label htmlFor="admin-whatsapp" className="form-label">WhatsApp</label>
          <input
            id="admin-whatsapp"
            type="tel"
            placeholder="(00) 00000-0000"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="account-field">
          <label htmlFor="admin-email" className="form-label">E-mail</label>
          <input
            id="admin-email"
            autoComplete="email"
            placeholder="seu@email.com"
            required
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        </fieldset>
        <div className="account-form-actions">
          <button type="button" disabled={saving} onClick={() => { setFormData(profile); onCancel(); }} className="btn btn-outline-secondary">
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Salvando…" : "Salvar alterações"}
          </button>
        </div>
      </form>

      <section className="account-panel account-security" aria-labelledby="account-security-title">
        <div className="account-panel-heading">
          <span className="account-section-icon"><ShieldCheck size={20} /></span>
          <div><h2 id="account-security-title">Segurança da conta</h2></div>
        </div>
        <MfaToggle />
      </section>
    </div>
  );
};

export default ProfileFormAdmin;
